import React from "react";
import { Cross, Shield, Sword } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurManifesto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="vores-manifest" className="dark bg-background text-foreground py-16 md:py-24 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={cn("max-w-6xl mx-auto transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        {}
        <div className="bg-[hsl(40,20%,94%)] text-[hsl(220,15%,5%)] border-2 border-[hsl(220,15%,5%)] shadow-[8px_8px_0px_0px_hsl(220,15%,5%)] flex flex-col md:flex-row">
          
          {}
          <div className="md:w-32 lg:w-40 bg-[hsl(40,20%,90%)] border-b-2 md:border-b-0 md:border-r-2 border-[hsl(220,15%,5%)] flex items-center justify-center py-8 md:py-0 relative overflow-hidden">
            {}
            <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/paper-fibers.png')] mix-blend-multiply pointer-events-none"></div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-widest uppercase md:[writing-mode:vertical-rl] md:rotate-180 text-[hsl(220,15%,5%)] opacity-90 whitespace-nowrap select-none">
              Samfund & Moral • Disciplin & Karakterstyrke • Tro & Eksistens
            </h2>
          </div>

          {}
          <div className="flex-1 p-8 md:p-16 lg:p-20 relative">
             {}
             <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/paper-fibers.png')] mix-blend-multiply pointer-events-none"></div>

            <div className="relative z-10 max-w-3xl mx-auto">
              <div className="flex items-center gap-4 mb-8 opacity-80">
                <Shield className="size-8 stroke-2" />
                <span className="text-sm font-bold tracking-widest uppercase border-b border-[hsl(220,15%,5%)] pb-1">
                  Officielt Manifest
                </span>
              </div>

              <div className="space-y-8 font-serif text-lg md:text-xl leading-relaxed text-[hsl(220,15%,5%)]">
                <p>
                  Jeg er Christian Bak, og dette er min urokkelige platform for en <span className="bg-[hsl(45,50%,50%)] text-white px-1 font-medium box-decoration-clone">kompromisløs samfundsdebat</span>. Her forenes den jernhårde militære disciplin fra Den Kongelige Livgarde med en dyb forankring i kristen etik. Vi kræver et opgør med hykleri og den moderne ansvarsforflygtigelse, idet vi insisterer på det enkelte menneskes fundamentale og <span className="font-bold">personlige ansvar</span> over for Gud og fædreland.
                </p>

                <div className="flex justify-center py-2">
                  <Cross className="size-6 text-[hsl(220,15%,5%)] opacity-60" />
                </div>

                <p>
                  Sand karakter formes ikke i magelighed, men i modstand. Min vej fra kaos til orden er fortællingen om en nødvendig <span className="bg-[hsl(45,50%,50%)] text-white px-1 font-medium box-decoration-clone">karakterdannelse</span> gennem bøn og streng vilje. Vi står som værn for de ufødte og de glemte, drevet af en kriger-ethos der nægter at bøje sig for tidsåndens moralske forfald. Her er intet plads til svaghed; kun til den rå vilje til forandring og personligt ansvar.
                </p>

                <div className="flex justify-center py-2">
                  <Sword className="size-6 text-[hsl(220,15%,5%)] opacity-60" />
                </div>

                <p>
                  Betragt dette som et digitalt fort. I en verden af støj og overfladiskhed leverer vi sandheden råt for usødet, præcis som de etablerede medier frygter den. Gennem en <span className="bg-[hsl(45,50%,50%)] text-white px-1 font-medium box-decoration-clone">saglig samfundsdebat</span> og et totalt opgør med hykleri, genrejser vi de værdier, der byggede vores fundament: disciplin, substans og kristen tro.
                </p>
              </div>

              <div className="mt-12 pt-8 border-t border-[hsl(220,15%,5%)]/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <div className="flex flex-col">
                  <span className="font-serif italic text-lg">Christian Bak</span>
                  <span className="text-xs uppercase tracking-wider opacity-70">Grundlægger & Tidligere Garder</span>
                </div>
                
                <Button asChild className="bg-[hsl(220,15%,5%)] text-[hsl(40,20%,94%)] hover:bg-[hsl(220,15%,5%)]/90 rounded-none border-2 border-transparent hover:border-[hsl(45,50%,50%)] transition-all shadow-none hover:shadow-[4px_4px_0px_0px_hsl(45,50%,50%)]" size="lg">
                  <Link to="/JourneyPage">
                    Læs om Rejsen
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}